import React, { Component } from "react";
import { connect } from "react-redux";
import { Card, CardBody, Row, Col } from "reactstrap";
import { metadataService, FinancialService } from "../../_services";
import PropTypes from "prop-types";
import { SlBusyIndicator, SLDetailsTable, SlSectionTitle, SLCardSelectable } from "../editors";
import pencil from "../images/SL-pencil.svg";

class FinancialDetails extends Component {
    constructor() {
        super();
    }
    render() {
        const { employers, incomes, showEdit } = this.props;
        return (
            <div className="mt-3">
                <SlSectionTitle className="mb-0" sectionName="MyIncome" />
                {showEdit && (
                    <Row className="mt-0">
                        <Col xs={12} className="text-right">
                            <small
                                className="cursor-pointer"
                                title={metadataService.getButton("ClickToEdit")}
                                onClick={this.props.onEdit}
                            >
                                <img style={{ width: "1.5rem" }} src={pencil} />
                            </small>
                        </Col>
                    </Row>
                )}
                <Card>
                    <CardBody className={"p-0"}>
                        {employers &&
                            [...employers]
                                .filter((s) => s.isDelete !== true)
                                .map((source) => {
                                    return (
                                        <div>
                                            <SLDetailsTable
                                                dataSource={[
                                                    {
                                                        label:
                                                            metadataService.getFieldNameLabel(
                                                                "IncomeSourceShort"
                                                            ),
                                                        value: source.employerName,
                                                        className: "bg-light",
                                                        required: true,
                                                        hasError: metadataService.isNullOrEmpty(
                                                            source.employerName
                                                        ),
                                                    },
                                                    {
                                                        label:
                                                            metadataService.getFieldNameLabel("NetIncome"),
                                                        value:
                                                            !metadataService.isNullOrEmpty(
                                                                source.incomePerPeriod
                                                            ) &&
                                                                !metadataService.isNullOrEmpty(
                                                                    source.payFrequency
                                                                )
                                                                ? `${metadataService.formatMoney(
                                                                    source.incomePerPeriod
                                                                )} ${metadataService.getLookupText(
                                                                    metadataService.LOOKUP_INCOMEFREQUENCY,
                                                                    source.payFrequency
                                                                )}`
                                                                : "",
                                                        required: true,
                                                        hasError:
                                                            metadataService.isNullOrEmpty(
                                                                source.incomePerPeriod
                                                            ) ||
                                                            metadataService.isNullOrEmpty(
                                                                source.payFrequency
                                                            ),
                                                    },
                                                    {
                                                        label:
                                                            metadataService.getFieldNameLabel("TimeEmployed"),
                                                        value:
                                                            metadataService.isNullOrEmpty(source.years) === false &&
                                                                metadataService.isNullOrEmpty(source.months) === false
                                                                ? metadataService.formatDuration(
                                                                    source.years,
                                                                    source.months
                                                                )
                                                                : "",
                                                        required: true,
                                                        hasError:
                                                            metadataService.isNullOrEmpty(source.years) ||
                                                            metadataService.isNullOrEmpty(source.months),
                                                    },
                                                    {
                                                        label: metadataService.getFieldNameLabel("Address"),
                                                        value:
                                                            !metadataService.isNullOrEmpty(source.address1) &&
                                                                !metadataService.isNullOrEmpty(source.city) &&
                                                                !metadataService.isNullOrEmpty(source.state) &&
                                                                !metadataService.isNullOrEmpty(source.postalCode)
                                                                ? metadataService.formatAddress(
                                                                    source.address1,
                                                                    source.address2,
                                                                    source.city,
                                                                    source.state,
                                                                    source.postalCode
                                                                )
                                                                : "",
                                                    },
                                                    {
                                                        label:
                                                            metadataService.getFieldNameLabel("WorkNumber"),
                                                        value: metadataService.isNullOrEmpty(
                                                            source.workNumber
                                                        ) === false ? metadataService.formatPhoneNumber(
                                                            source.workNumber
                                                        )
                                                            : "",
                                                    },
                                                ]}
                                            ></SLDetailsTable>
                                            <br />
                                        </div>
                                    );
                                })}

                        {incomes &&
                            [...incomes]
                                .filter((s) => s.isDelete !== true)
                                .map((source) => {
                                    return (
                                        <div>
                                            <SLDetailsTable
                                                dataSource={[
                                                    {
                                                        label:
                                                            metadataService.getFieldNameLabel(
                                                                "IncomeSourceShort"
                                                            ),
                                                        value: source.otherIncomeSource
                                                            ? metadataService.getLookupText(
                                                                "otherIncomeSource",
                                                                source.otherIncomeSource
                                                            )
                                                            : "",
                                                        className: "bg-light",
                                                        required: true,
                                                        hasError: metadataService.isNullOrEmpty(
                                                            source.otherIncomeSource
                                                        ),
                                                    },
                                                    {
                                                        label:
                                                            metadataService.getFieldNameLabel("NetIncome"),
                                                        value: !metadataService.isNullOrEmpty(source.amount)
                                                            ? `${metadataService.formatMoney(
                                                                source.amount
                                                            )} ${metadataService.getLookupText(
                                                                metadataService.LOOKUP_INCOMEFREQUENCY,
                                                                source.payFrequency || 4
                                                            )}`
                                                            : "",
                                                        required: true,
                                                        hasError: metadataService.isNullOrEmpty(
                                                            source.amount
                                                        ),
                                                    },
                                                ]}
                                            ></SLDetailsTable>
                                            <br />
                                        </div>
                                    );
                                })}
                        {(metadataService.isNullOrEmpty(employers) && metadataService.isNullOrEmpty(incomes)) && <SLDetailsTable dataSource={[]} />}

                    </CardBody>
                </Card>
            </div>
        );
    }
}
FinancialDetails.propTypes = {
    onEdit: PropTypes.func,
    showEdit: PropTypes.bool
};


function mapStateToProps(state) {
    return {
        language: state.users.language
    };
}

function mapDispatchToProps(dispatch) {
    return {};
}
const connectedViewProfile = connect(
    mapStateToProps,
    mapDispatchToProps
)(FinancialDetails);
export { connectedViewProfile as FinancialDetails };
